import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { ScrollPositionService } from 'src/app/core/services/scroll-position.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: [],
})
export class MainLayoutComponent implements OnInit {

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;

  isCollapsed = false;
  isResponsiveTable = false;
  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  @ViewChild(MatSidenavContent) sidenavContent!: MatSidenavContent;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  constructor(private breakpointObserver: BreakpointObserver, private scrollService: ScrollPositionService) {
    // this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes

        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    const container = this.sidenavContent.getElementRef().nativeElement;
    this.scrollService.setScrollRef(container);
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  // toggleCollapsed() {
  //   this.isContentWidthFixed = false;
  // }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.isCollapsed = !this.isCollapsed; // Đảo trạng thái thu gọn
    this.isResponsiveTable = !this.isResponsiveTable;
  }
}
